import { Component, Inject, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { MSI_MODAL_DATA, MsiModalRef, ModalModule } from '@msi/cobalt';
import { ModalData } from 'src/app/interfaces/modal.interface';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from '@msi/cobalt/checkbox';
import { IconModule } from '@msi/cobalt/icon';

/** Maximum amount of characters in a node/group's title */
export const NODE_TITLE_MAX_LENGTH = 64;

@Component({
	selector: 'app-basic-modal-component',
	templateUrl: './basic-modal.component.html',
	styleUrls: ['./basic-modal.component.scss'],
	standalone: true,
	imports: [ModalModule, IconModule, CheckboxModule, FormsModule],
})
export class BasicModalComponent implements OnInit, OnDestroy {
	@ViewChild('input') input: ElementRef;

	confirmText: string;
	actionButtonText: string;
	cancelButtonText: string;
	userInput: string;
	dontAskAgain: boolean;
	confirmDisabled = true;
	inputErrorMessage: string;
	destroy: Subject<void> = new Subject();

	constructor(
		public modalRef: MsiModalRef,
		@Inject(MSI_MODAL_DATA) public data: ModalData
	) {}

	ngOnInit() {
		this.dontAskAgain = this.data.checkboxChecked;
		this.confirmText = this.data.confirmText ?? $localize`Confirm`;
		this.actionButtonText = this.data.actionButtonText;
		this.cancelButtonText = this.data.cancelButtonText ?? $localize`Cancel`;
		if (this.data.showTextInput) {
			// Set the text input's contents to the node's current title
			this.userInput = this.data.friendlyName;
		} else {
			this.confirmDisabled = false;
		}
	}

	ngOnDestroy(): void {
		this.destroy.next();
		this.destroy.complete();
	}

	confirm() {
		this.modalRef.close({
			dontAskAgain: this.dontAskAgain ? true : false,
			userInput: this.userInput,
			canceled: false,
		});
	}

	actionButton() {
		this.data.actionCallback?.();
	}

	cancel() {
		this.modalRef.close({ canceled: true });
	}

	/**
	 * If user input is invalid, disable the confirmation button
	 * and display reason input is invalid
	 */
	validateInput() {
		this.inputErrorMessage = this.data.inputValidationCallback(this.userInput);
		if (this.inputErrorMessage && (!this.userInput || this.userInput !== this.data.originalName)) {
			this.confirmDisabled = true;
			return;
		}
		this.confirmDisabled = false;
	}

	resetName() {
		this.userInput = this.data.originalName;
		this.validateInput();
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
